import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { applyTheme, normalizeTheme } from '../theme';
import { useAuth } from './AuthContext';

const ThemeContext = createContext();
const API = window.__CRM_API__ || `${window.location.origin}/api`;

export const ThemeProvider = ({ children }) => {
  const { usuario, loading: authLoading } = useAuth();
  const [theme, setThemeState] = useState(() => normalizeTheme(localStorage.getItem('qlf-theme')));

  useEffect(() => {
    if (authLoading) return undefined;
    if (!usuario?.id) {
      setThemeState(applyTheme(localStorage.getItem('qlf-theme')));
      return undefined;
    }
    let active = true;
    axios.get(`${API}/auth/me/profile`).then(({ data }) => {
      if (!active) return;
      setThemeState(applyTheme(data?.preferences?.theme));
    }).catch(() => {
      // Keep the locally selected palette during a temporary profile failure.
      if (active) setThemeState(applyTheme(localStorage.getItem('qlf-theme')));
    });
    return () => { active = false; };
  }, [authLoading, usuario?.id]);

  const setTheme = useCallback(async (nextTheme) => {
    const next = normalizeTheme(nextTheme);
    const previous = theme;
    setThemeState(applyTheme(next));
    try {
      const { data } = await axios.put(`${API}/auth/me/preferences`, { preferences: { theme: next } });
      const saved = normalizeTheme(data?.preferences?.theme);
      setThemeState(applyTheme(saved));
      return saved;
    } catch (error) {
      setThemeState(applyTheme(previous));
      throw error;
    }
  }, [theme]);

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => {
  const value = useContext(ThemeContext);
  if (!value) throw new Error('useTheme debe usarse dentro de ThemeProvider');
  return value;
};
